import _styled from "@emotion/styled-base";
import React from 'react';
import Loadable from '@loadable/component';
import { MapMarker } from './MapMarker';
import { GOOGLE_MAPS_GEOCODING_API_KEY } from '@jelly/utils';
var GoogleMapReact = Loadable(function () {
  return import(
  /* webpackChunkName: 'maps' */
  'google-map-react');
});

var MapContainer = _styled("div", {
  target: "e1omf34n0",
  label: "MapContainer"
})("display:block;height:", function (_ref) {
  var height = _ref.height;
  return height;
}, ";position:relative;width:", function (_ref2) {
  var width = _ref2.width;
  return width;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9NYXAvaW5kZXguanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVMrQiIsImZpbGUiOiIuLi8uLi9zcmMvTWFwL2luZGV4LmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCB7IG51bWJlciwgc3RyaW5nIH0gZnJvbSAncHJvcC10eXBlcydcbmltcG9ydCBMb2FkYWJsZSBmcm9tICdAbG9hZGFibGUvY29tcG9uZW50J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBNYXBNYXJrZXIgfSBmcm9tICcuL01hcE1hcmtlcidcbmltcG9ydCB7IEdPT0dMRV9NQVBTX0dFT0NPRElOR19BUElfS0VZIH0gZnJvbSAnQGplbGx5L3V0aWxzJ1xuXG5jb25zdCBHb29nbGVNYXBSZWFjdCA9IExvYWRhYmxlKCgpID0+IGltcG9ydCgvKiB3ZWJwYWNrQ2h1bmtOYW1lOiAnbWFwcycgKi8gJ2dvb2dsZS1tYXAtcmVhY3QnKSlcblxuY29uc3QgTWFwQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcblx0ZGlzcGxheTogYmxvY2s7XG5cdGhlaWdodDogJHsoeyBoZWlnaHQgfSkgPT4gaGVpZ2h0fTtcblx0cG9zaXRpb246IHJlbGF0aXZlO1xuXHR3aWR0aDogJHsoeyB3aWR0aCB9KSA9PiB3aWR0aH07XG5gXG5cbk1hcC5wcm9wVHlwZXMgPSB7XG5cdC8qKiBTcGVjaWZpYyBoZWlnaHQgb2YgbWFwIGNvbnRhaW5lciAqL1xuXHRoZWlnaHQ6IHN0cmluZyxcblx0LyoqIExhdGl0dWRlIGNvb3JkaW5hdGUgb2YgbG9jYXRpb24gKi9cblx0bGF0aXR1ZGU6IG51bWJlci5pc1JlcXVpcmVkLFxuXHQvKiogTG9uZ2l0dXRlIGNvb3JkaW5hdGUgb2YgbG9jYXRpb24gKi9cblx0bG9uZ2l0dWRlOiBudW1iZXIuaXNSZXF1aXJlZCxcblx0LyoqIFNwZWNpZmljIHdpZHRoIG9mIG1hcCBjb250YWluZXIgKi9cblx0d2lkdGg6IHN0cmluZyxcblx0LyoqIEFtb3VudCBvZiB6b29tIGFwcGxpZWQgdG8gdGhlIG1hcCAoaGlnaGVyIG51bWJlciA9IGNsb3NlcikgKi9cblx0em9vbTogbnVtYmVyLFxufVxuXG4vKipcbiAqIE1hcCBDb21wb25lbnQsIGRpc3BsYXlzIGEgZ29vZ2xlIG1hcCB3aXRoIGNlcnRhaW4gY29vcmRpbmF0ZXNcbiAqIFRha2VzIHVwIHRoZSBlbnRpcmUgd2lkdGggYW5kIGhlaWdodCBvZiBwYXJlbnQgdW5sZXNzIG90aGVyd2lzZSBzdGF0ZWRcbiAqIFdyYXBwZWQgaW4gTG9hZGFibGVcbiAqXG4gKiBEZWZhdWx0IE1hcDogQkRDIFdhbHRoYW0gTG9jYXRpb25cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIE1hcCh7IGhlaWdodCA9ICcxMDB2aCcsIGxhdGl0dWRlID0gNDIuMzkxMzg5LCBsb25naXR1ZGUgPSAtNzEuMjU2NTE2LCB3aWR0aCA9ICcxMDB2dycsIHpvb20gPSA4IH0pIHtcblx0cmV0dXJuIChcblx0XHQ8TWFwQ29udGFpbmVyIGhlaWdodD17aGVpZ2h0fSB3aWR0aD17d2lkdGh9PlxuXHRcdFx0PEdvb2dsZU1hcFJlYWN0XG5cdFx0XHRcdGJvb3RzdHJhcFVSTEtleXM9e3sga2V5OiBHT09HTEVfTUFQU19HRU9DT0RJTkdfQVBJX0tFWSB9fVxuXHRcdFx0XHRkZWZhdWx0Q2VudGVyPXt7IGxhdDogbGF0aXR1ZGUsIGxuZzogbG9uZ2l0dWRlIH19XG5cdFx0XHRcdGRlZmF1bHRab29tPXt6b29tfVxuXHRcdFx0XHRjZW50ZXI9e3sgbGF0OiBsYXRpdHVkZSwgbG5nOiBsb25naXR1ZGUgfX1cblx0XHRcdFx0em9vbT17em9vbX1cblx0XHRcdD5cblx0XHRcdFx0PE1hcE1hcmtlciAvPlxuXHRcdFx0PC9Hb29nbGVNYXBSZWFjdD5cblx0XHQ8L01hcENvbnRhaW5lcj5cblx0KVxufVxuIl19 */"));

/**
 * Map Component, displays a google map with certain coordinates
 * Takes up the entire width and height of parent unless otherwise stated
 * Wrapped in Loadable
 *
 * Default Map: BDC Waltham Location
 */
export function Map(_ref3) {
  var _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? '100vh' : _ref3$height,
      _ref3$latitude = _ref3.latitude,
      latitude = _ref3$latitude === void 0 ? 42.391389 : _ref3$latitude,
      _ref3$longitude = _ref3.longitude,
      longitude = _ref3$longitude === void 0 ? -71.256516 : _ref3$longitude,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? '100vw' : _ref3$width,
      _ref3$zoom = _ref3.zoom,
      zoom = _ref3$zoom === void 0 ? 8 : _ref3$zoom;
  return /*#__PURE__*/React.createElement(MapContainer, {
    height: height,
    width: width
  }, /*#__PURE__*/React.createElement(GoogleMapReact, {
    bootstrapURLKeys: {
      key: GOOGLE_MAPS_GEOCODING_API_KEY
    },
    defaultCenter: {
      lat: latitude,
      lng: longitude
    },
    defaultZoom: zoom,
    center: {
      lat: latitude,
      lng: longitude
    },
    zoom: zoom
  }, /*#__PURE__*/React.createElement(MapMarker, null)));
}